import { Pipe, PipeTransform } from '@angular/core';

/**
 * Joins an array of objects into a string by a given property.
 *
 * Example:
 *   [{ name: 'A' }, { name: 'B' }] -> "A, B"
 *
 * Useful for displaying lists (e.g. regions, sites) without
 * manual looping or comma handling in templates.
 * Null and undefined values are filtered out, and the separator can be customized.
 */
@Pipe({
    name: 'joinBy',
    standalone: false,
})
export class JoinByPipe implements PipeTransform {
    transform<T extends Record<string, unknown>>(
        items: T[] | null | undefined,
        key: keyof T,
        separator = ', '
    ): string {
        if (!items?.length) {
            return '';
        }

        return items
            .map(item => item[key])
            .filter(value => value !== null && value !== undefined)
            .map(value => `${value}`)
            .join(separator);
    }
}
